import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'

import GlobalRoutes from '../global'

interface ConnectedRoutesProps {
    locale?: string
}

/**
 * Detect access to /<locale>/index.html so we can normalise the URL
 * to /<locale>/ before mounting the router.
 */
const isIndexHtml = (locale: string): boolean =>
    window.location.pathname === `${locale}/index.html`

/**
 * Top-level connected router. Wraps the global route table in a
 * `BrowserRouter` scoped to the current locale.
 */
const ConnectedRoutes = ({ locale = '' }: ConnectedRoutesProps) => {
    useEffect(() => {
        if (isIndexHtml(locale)) {
            window.location.href = `${locale}/`
        }
    }, [locale])

    return (
        <BrowserRouter basename={locale}>
            <GlobalRoutes />
        </BrowserRouter>
    )
}

export default ConnectedRoutes
